// src/config.js

// В режиме разработки используем localhost, а в сборке - пустую строку (чтобы запросы шли от текущего домена https://oqsaroycardio.uz)
export const BASE_URL = process.env.NODE_ENV === 'production' 
    ? "" 
    : "http://localhost:5000";

export const API_URL = process.env.NODE_ENV === 'production' 
    ? "/api"
    : `${BASE_URL}/api`;
